(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kinda-brand-intro"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kinda-story-slider'))customElements.define('kinda-story-slider',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();let signal=this.abort.signal;this.slides=[...this.querySelectorAll('[data-slide]')];this.dots=[...this.querySelectorAll('[data-select]')];this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovered=false;this.focused=false;this.addEventListener('click',e=>{let b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-select'))this.show(Number(b.dataset.select));else if(b.hasAttribute('data-prev'))this.show(this.index-1);else if(b.hasAttribute('data-next'))this.show(this.index+1);else if(b.hasAttribute('data-pause')){this.paused=!this.paused;b.textContent=this.paused?'▶':'Ⅱ';b.setAttribute('aria-label',this.paused?b.dataset.playLabel:b.dataset.pauseLabel);this.schedule()}},{signal});this.addEventListener('pointerenter',()=>{this.hovered=true;this.schedule()},{signal});this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule()},{signal});this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},{signal});this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule()}},{signal});document.addEventListener('visibilitychange',()=>this.schedule(),{signal});this.schedule()}
 show(n){this.index=(n+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>{let a=i===this.index;s.classList.toggle('is-active',a);s.setAttribute('aria-hidden',String(!a));s.inert=!a;this.dots[i].setAttribute('aria-pressed',String(a))});this.schedule()}
 schedule(){clearTimeout(this.timer);if(!this.paused&&!this.hovered&&!this.focused&&!document.hidden)this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.interval)||3000)}
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinda-campaign"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kinda-home-slider')) {
  customElements.define('kinda-home-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.tabs = [...this.querySelectorAll('[data-select]')];
      this.track = this.querySelector('.kinda-home-slider__slides');
      this.pauseButton = this.querySelector('[data-pause]');
      this.index = Math.max(0, this.slides.findIndex(s => s.classList.contains('is-active')));
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.hovered = false;
      this.focused = false;
      this.querySelector('.kinda-home-slider__controls').hidden = false;
      this.addEventListener('click', e => {
        const button = e.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-pause')) {
          this.paused = !this.paused;
          this.updatePlayback();
        } else if (button.hasAttribute('data-select')) this.show(Number(button.dataset.select));
        else if (button.hasAttribute('data-next')) this.show(this.index + 1);
        else if (button.hasAttribute('data-prev')) this.show(this.index - 1);
      }, {signal});
      this.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, {signal});
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.schedule(); } }, {signal});
      this.addEventListener('keydown', e => {
        if (!['ArrowLeft','ArrowRight'].includes(e.key)) return;
        e.preventDefault();
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.show(this.index + ((e.key === 'ArrowRight') !== rtl ? 1 : -1));
        this.tabs[this.index].focus();
      }, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.reduced.addEventListener('change', () => { if(this.reduced.matches) this.paused = true; this.updatePlayback(); }, {signal});
      this.updatePlayback();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        this.tabs[i].setAttribute('aria-pressed', String(active));
      });
      this.schedule();
    }
    updatePlayback() {
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      this.pauseButton.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const stopped = this.paused || this.hovered || this.focused || document.hidden;
      this.track.setAttribute('aria-live', stopped ? 'polite' : 'off');
      if (!stopped) this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 3000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinda-daily-deals"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kinda-daily-flash'))customElements.define('kinda-daily-flash',class extends HTMLElement{
 connectedCallback(){const end=Date.parse(this.dataset.expiry);const out=this.querySelector('[data-countdown]');if(!out||!Number.isFinite(end))return;const tick=()=>{const secs=Math.max(0,Math.floor((end-Date.now())/1000));const hh=String(Math.floor(secs/3600)).padStart(2,'0');const mm=String(Math.floor(secs%3600/60)).padStart(2,'0');const ss=String(secs%60).padStart(2,'0');out.textContent=hh+':'+mm+':'+ss;if(secs===0){clearInterval(this.clock);location.reload()}};tick();this.clock=setInterval(tick,1000)}
 disconnectedCallback(){clearInterval(this.clock)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
